'use client'

import { usePathname } from 'next/navigation'
import { formatImageURL, formatDateNormal } from '@/utils/util'
import { getReadingTime, getExcerpt } from '@/utils/blog'
import { navigateUrl } from '@/utils/client-request'

type Variant = 'standard' | 'side'

export default function BlogCard({ blog, variant = 'standard' }: { blog: any, variant?: Variant }) {
  const pathname = usePathname() || ''
  const href = navigateUrl(`/blog/${blog.id}`, pathname)
  const date = blog?.createdAt ? formatDateNormal(new Date(blog.createdAt)) : ''
  const mins = getReadingTime(blog?.content || '')
  const excerpt = getExcerpt(blog?.content || '', 160)

  if (variant === 'side') {
    return (
      <a href={href} className="group flex items-start gap-4 py-5 border-b border-foreground/10 last:border-b-0 first:pt-0 cursor-pointer">
        <div className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-xl overflow-hidden shrink-0 bg-[#F1EEE7]">
          <img src={formatImageURL(blog.thumbnail || 'placeholder.png')} alt={blog.title} className="absolute inset-0 w-full h-full object-cover" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-[15px] sm:text-[17px] font-semibold font-gilroy tracking-[-0.01em] leading-[1.25] line-clamp-2 text-foreground group-hover:underline">
            {blog.title}
          </h4>
          <div className="mt-1.5 text-[12px] text-foreground/55">
            {date}{date && mins ? ' · ' : ''}{mins ? `${mins} мин` : ''}
          </div>
        </div>
      </a>
    )
  }

  return (
    <a href={href} className="group cursor-pointer block">
      <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-[#F1EEE7]">
        <img
          src={formatImageURL(blog.thumbnail || 'placeholder.png')}
          alt={blog.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
        />
      </div>
      <div className="mt-4">
        <h3 className="text-[20px] sm:text-[22px] font-bold font-gilroy tracking-[-0.015em] leading-[1.15] text-foreground group-hover:underline">
          {blog.title}
        </h3>
        {excerpt && (
          <p className="mt-2 text-[14px] text-foreground/60 leading-6 line-clamp-2">{excerpt}</p>
        )}
        <div className="mt-4 text-[12px] text-foreground/55">
          {date}{date && mins ? ' · ' : ''}{mins ? `${mins} мин унших` : ''}
        </div>
      </div>
    </a>
  )
}
